<template>
    <div class="flex justify-center items-center h-screen text-center bg-white fixed top-0 w-screen z-10 pb-12">
        <div class="spinner"></div>
    </div>
</template>